import { RemoveScrollSideCar as r } from "./index.es449.js";
import { effectCar as o } from "./index.es447.js";
import { exportSidecar as e } from "./index.es450.js";
const f = e(o, r);
export {
  f as default
};
//# sourceMappingURL=index.es374.js.map
